export default __webpack_public_path__ + "static/media/avatar1.39e2525c.png";